// Result Popup Component
export const ResultPopup = ({ result, onClose, rollAgain }) => {
    if (!result) return null;
    
    const { won, choice, resultNumber, wager, payout } = result;
    const diceImage = `${process.env.PUBLIC_URL}/dice/${resultNumber}.png`;
    
    return (
      <div className="popup-overlay">
        <div className={`result-popup ${won ? 'won' : 'lost'}`}>
          <div className="popup-header">
            <h2>{won ? '🎉 YOU WON! 🎉' : '😢 You Lost'}</h2>
            <button className="popup-close" onClick={onClose}>×</button>
          </div>
          
          <div className="popup-content">
            <div className="dice-result-display">
              <div className="dice-comparison">
                <div className="dice-choice">
                  <div className="dice-label">Your Choice</div>
                  <div className="dice-image-container">
                    <img 
                      src={`${process.env.PUBLIC_URL}/dice/${choice}.png`} 
                      alt={`Dice ${choice}`}
                      className="dice-image"
                    />
                    <div className="dice-number">{choice}</div>
                  </div>
                </div>
                
                <div className="versus">VS</div>
                
                <div className="dice-result">
                  <div className="dice-label">Result</div>
                  <div className="dice-image-container">
                    <img 
                      src={diceImage} 
                      alt={`Dice ${resultNumber}`}
                      className="dice-image result-dice"
                    />
                    <div className="dice-number">{resultNumber}</div>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="result-details">
              <div className="result-row">
                <span>Wager:</span>
                <strong>{wager} DERP</strong>
              </div>
              {won ? (
                <div className="result-row">
                  <span>Payout:</span>
                  <strong className="payout-highlight">{payout} DERP</strong>
                </div>
              ) : null}
            </div>
            
            <div className="popup-message">
              {won ? (
                <div className="win-message">
                  <h3>Congratulations!</h3>
                  <p>You won <strong className="payout-highlight">{payout} DERP</strong>!</p>
                </div>
              ) : (
                <div className="lose-message">
                  <h3>Better luck next time!</h3>
                  <p>The dice rolled {resultNumber}.</p>
                </div>
              )}
            </div>
            
            <button className="popup-action-btn" onClick={rollAgain}>
              Repeat Roll
            </button>
          </div>
        </div>
      </div>
    );
  };